<div class="radio">
    <label *ngIf="title" class="title">{{ title }}</label>
    <div class="options-group">
        <div class="option" *ngFor="let opt of options">
            <input type="radio" [value]="opt.value" [name]="name"
                class="opt" [checked]="opt.selected || selectedValue == opt.value" [disabled]="opt.disabled"
                (change)="emitOption(opt.value || '')">
            <label for="opt">
                {{ opt.label }}
            </label>
        </div>
    </div>
</div>